module.exports = __webpack_public_path__ + "static/logo_colour_background-864e1c1aeda75e1649e5d16c8fc63ab7.svg";